export default class TraderConfiguration {
  maxOfferQuantities: number[] = null;
  priceLockOptions: string[] = null;
}
